module.exports = __webpack_public_path__ + "img/part7_x2.9b1b2085.png";